export class DiscussionCharacter {
  constructor(label, img) {
    this.label = label;
    this.img = img;
  }
}
